import { useState, useContext } from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { SubscribedContext } from "@/providers/Subscribed";
import { postVote } from "@/services/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function PollCard({ content, setVoted }) {
  const [selected, setSelected] = useState(null);

  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (option) => postVote(content.key, option),
    onSuccess: () => {
      setVoted(true);
      queryClient.invalidateQueries({ queryKey: ["poll_results"] });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  const handleClickVote = (option) => {
    if (!isSubscribed) {
      handleModalOpen();
      return;
    }
    setSelected(option);
    mutation.mutate(option);
  };

  return (
    <Card style={{ borderRadius: "10px" }}>
      <CardContent>
        <Typography
          variant="body1"
          sx={{ mb: 2 }}
          style={{ fontWeight: "bold" }}
        >
          Q: {content.meta.question}
        </Typography>
        {content.meta.options
          .filter((option) => option)
          .map((option, index) => (
            <Box
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button
                variant={selected === option ? "contained" : "outlined"}
                color="secondary"
                fullWidth
                style={{ borderRadius: "30px", margin: "10px 0" }}
                onClick={() => handleClickVote(option)}
                disabled={mutation.isPending}
              >
                {option}
              </Button>
            </Box>
          ))}
      </CardContent>
    </Card>
  );
}
